import React, { forwardRef, useImperativeHandle } from "react";
import { useState } from "react";
import tw from "twin.macro";
import { ReactComponent as HomeIcon } from "../../../Images/home_logo.svg";
import { ReactComponent as List } from "../../../Images/list.svg";
import { ReactComponent as BreadCrumRightArrow } from "../../../Images/breadcrumb-right-arrow.svg";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
const Breadcrumb = tw.div`flex pl-5 md:pl-0 pt-24 lg:pt-24 flex-col z-10`;
const BreadcrumbNav = tw.nav`flex md:pl-16 lg:pl-16 sm:pl-5`;
const OrderList = tw.ol`inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse`;
const BreadcrumbList = tw.li`inline-flex items-center`;
const Anchor = tw.a`inline-flex items-center border-b-2 border-transparent hover:cursor-pointer hover:border-primary-700 text-sm`;
const Anchorr = tw.a`inline-flex items-center border-transparent hover:cursor-pointer  text-sm`;
const SvgRightArrow = tw.div`flex items-center hover:cursor-pointer`;

const DropDown = styled.div`
  ${tw`absolute ml-1 bg-gray-100 text-lg text-gray-900 z-50`}
  width:18rem;
  margin-top: 23rem;
  z-index:5;
`;

const DropDownAnchor = tw.a`relative inline-flex items-center w-full px-4 pb-1 text-sm hover:cursor-pointer border-b border-gray-200 hover:bg-blue-200 hover:text-primary-500 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-200 dark:hover:bg-blue-100 dark:hover:text-primary-400 dark:focus:ring-gray-500 dark:focus:text-black z-20`;

const BreadCrumbs = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  const handleClick = () => {
    setShow((p) => !p);
  };
  
  useImperativeHandle(ref, () => ({
    handleClick: () => {
      if (show) {
        setShow((p) => !p);
      }
    },
  }));

  let BreadCrumbList=[
    {
      title:"Real Estate Software",
      routeUrl:"/what-we-do/real-estate-software-company"
    },
    {
      title:"Cloud Services",
      routeUrl:"/what-we-do/cloud-services"
    },
    {
      title:"Customer identity & access management",
      routeUrl:"/what-we-do/customer-identity-and-access-management"
    },
    {
      title:"Digital Transformation",
      routeUrl:"/what-we-do/digital-transformation-services"
    },
    {
      title:"Application-in-a-box",
      routeUrl:"/what-we-do/application-framework"
    },
    {
      title:"Application Development",
      routeUrl:"/our-services/application-development"
    },
    {
      title:"API Development",
      routeUrl:"/our-services/api-development"
    },
    {
      title:"Application Maintenance",
      routeUrl:"/our-services/application-support"
    },
    {
      title:"API Integrations",
      routeUrl:"/our-services/third-party-api-integrations"
    },
    {
      title:"Dedicated Teams",
      routeUrl:"/our-services/dedicated-development-teams"
    },
    {
      title:"Product Engineering",
      routeUrl:"/our-services/product-engineering"
    }
  ]

  let DropDownAnchorList=BreadCrumbList.map((item) => {
    return (
      <DropDownAnchor onClick={() => navigate(item.routeUrl)}>
        {item.title}
      </DropDownAnchor>
    );
  })
const breadcrumbStyle={
  backgroundColor:`${props.bgcolor && "#EEF5FF"}`,
  borderBottom: `${props.bgcolor && "1px solid  #EEF5FF"}`,
}
  return (
    <Breadcrumb
      style={breadcrumbStyle}
    >
      <BreadcrumbNav aria-label="Breadcrumb">

        <OrderList >
        {
          window.innerWidth<=768 &&   <BreadcrumbList>
          {/* <Anchor > */}
          <List onClick={() => handleClick()} className={show && "text-primary-700"}/>
          {/* </Anchor> */}
        </BreadcrumbList>
        }
          <BreadcrumbList>
            <SvgRightArrow >
              {/* <BreadCrumRightArrow onMouseLeave={handleMouseLeave} /> */}
              <Anchor
                onMouseEnter={handleMouseEnter}
                className="ml-1"
                onClick={() => navigate("/", { state: "whatwedo" })}
              >
                { props.title1 }
              </Anchor>
            </SvgRightArrow>
            <SvgRightArrow >
            <BreadcrumbList
            // className={show && "rotate-90"}
            onMouseEnter={handleMouseEnter}
          >
            <SvgRightArrow onClick={() => handleClick()}>
              {/* <BreadCrumRightArrow  /> */} <span className="pl-2">/</span>
            </SvgRightArrow>
          </BreadcrumbList>
              <Anchorr
                // onMouseEnter={handleMouseEnter}
                className="ml-2"
                // onClick={() => navigate("/", { state: "whatwedo" })}
              >
              { props.title }
              </Anchorr>
            </SvgRightArrow>
            
            {show && (
              <DropDown onMouseLeave={handleMouseLeave} onClick={() => handleClick()}>
            {DropDownAnchorList}
              </DropDown>
            )}
          </BreadcrumbList>
          <BreadcrumbList
            className={show && "rotate-90"}
            onMouseEnter={handleMouseEnter}
          >
            <SvgRightArrow onClick={() => handleClick()}>
              {/* <BreadCrumRightArrow /> */}
            </SvgRightArrow>
          </BreadcrumbList>
        </OrderList>
      </BreadcrumbNav>
    </Breadcrumb>
  );
});

export default BreadCrumbs;
